import { useRef, useState } from 'react'
import { motionValue, useMotionValueEvent, useScroll } from 'framer-motion'

const useAnimLanding = () => {
  const landingRef = useRef(null)
  const { scrollY } = useScroll({
    target: landingRef,
    layoutEffect: false
  })

  const scrolledPixels = scrollY
  const [collapse, setCollapse] = useState(false)
  const [toggle, setToggle] = useState()

  useMotionValueEvent(scrolledPixels, 'change', l =>
    l >= window.innerHeight ? setCollapse(true) : setCollapse(false)
  )

  let volume = motionValue(1)

  useMotionValueEvent(scrolledPixels, 'change', l => {
    const newVolume = Math.max(1 - l / window.innerHeight, 0) // Volume fades as you scroll
    volume.set(newVolume)
    // console.log(volume.get())
    setCollapse(l >= window.innerHeight)
  })

  // const transitionBefore = 

  const closePath = `inset(40% 55%)`
  const openPath = `inset(0% 0%)`
  return {
    scrolledPixels,
    collapse,
    clip: {
      closePath,
      openPath
    },
    toggle,
    setToggle,
    // volume
  }
}

export default useAnimLanding
